<template>
  <AppAlert
    v-if="visible"
    banner
    hide-icon
    :variant="variant">
    We are having a problem billing the <strong>{{ organization.name }}</strong> organization.
    <template v-if="canManageBilling">
      Please <a href="/billing/edit" class="font-semibold underline">update your payment information</a>
      or call your payment provider for details on why the transaction failed.
    </template>
    <template v-else>
      Please contact your organization owner to resolve the billing issue.
    </template>
  </AppAlert>
</template>

<script setup>
import { computed } from 'vue'
import { AppAlert } from '@/components/ui'
import { useGlobalStore } from '@/stores/global'

const globalStore = useGlobalStore()
const organization = computed(() => globalStore.organization)

const visible = computed(() =>
  organization.value.subscriptionPastDue &&
  globalStore.user?.adminPrivileges &&
  !globalStore.user?.ssoUser &&
  globalStore.currentPath !== 'profile/billing')

const canManageBilling = computed(() => globalStore.user?.owner)

const variant = computed(() => (organization.value.daysPastDue > 3 ? 'danger' : 'warning'))
</script>
